import { AuthUser, ClientTypes, Role } from "../features/auth/types/authType";

export const isPrivilegedTransaction = (roles: Role[], privileged: string) => {
  return roles.some(
    (r) =>
      r &&
      r.displayName &&
      r.displayName.toLowerCase() === privileged.toLowerCase()
  );
};

export function getDefaultAppPath(user: AuthUser | undefined): string {
  if (
    user?.clientType === ClientTypes.ForeignAgent ||
    user?.company?.type === ClientTypes.ForeignAgent
  ) {
    return "/app/cvs";
  }
  if (user?.company?.depositAmount && user.company.depositAmount.length > 0) {
    return "/app/coms";
  }
  return "/app/employees";
}
